module.exports = __webpack_public_path__ + "img/icon-service6.4eed72b7.png";